<app-home [titre]="title"
          [menu]="menu"
          [avatar]="false"
          [showAccessibility]="true"
          [miniSidenav]="false"
          class="mat-typography"
          [darkTheme]="false" version="5.1">
</app-home>
<span *ngIf="showLoader" class="loading"></span>

